<template>
  <div id="new-employee">
      <h3>New Employee</h3>
      <form @submit.prevent="saveEmployee" class="col s12">
        <div class="input-field col s12">
          <input type="text" v-model="employeeId" required>
          <label>Employee ID</label>
        </div>
        <div class="input-field col s12">
          <input type="text" v-model="name" required>
          <label>Employee Name</label>
        </div>
        <div class="input-field col s12">
          <input type="text" v-model="department" required>
          <label>Employee Department</label>
        </div>
        <div class="input-field col s12">
          <input type="text" v-model="position" required>
          <label>Employee Position</label>
        </div>
        <button type="submit" class="btn">Submit</button>
        <router-link to="/" class="btn grey">Cancel</router-link>
      </form>
  </div>
</template>

<script>
import db from '../fbInit'
export default {
name: 'new-employee',
data() {
    return {
        employeeId: null,
        name: null,
        department: null,
        position: null
    }
},
methods: {
  saveEmployee() {
    db.collection('employees').add({
      employeeId: this.employeeId,
      name: this.name,
      department: this.department,
      position: this.position
    })
    .then(docRef => this.$router.push('/'))
    .catch(err => console.log(err))
  }
}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/Employee/NewEmployee.vue